'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import React, { useMemo } from 'react'
import { Toaster } from 'react-hot-toast'

interface Props {
  children: React.ReactNode
}

const QueryProvider = ({ children }: Props) => {
  const queryClient = useMemo(() => new QueryClient(), [])
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster />
      <>{children}</>
      <ReactQueryDevtools />
    </QueryClientProvider>
  )
}

export default QueryProvider
